export default "__VITE_ASSET__DUqW4Jd0__"